module.exports = __webpack_public_path__ + "img/packages_qty_report.1b07c73f.png";